import * as React from "react";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { withVar } from "themes/helpers";

interface IProps {
  keyName: string;
}

const KeyWrapper: React.FC<IProps> = ({ keyName }) => (
  <Flex
    height="24px"
    minWidth="24px"
    alignItems="center"
    justifyContent="center"
    bg={withVar(DesignToken.SurfaceInvertSecondary)}
    borderRadius="4px"
  >
    <Text
      fontSize="15px"
      lineHeight="22px"
      paddingH={withVar(SpacingToken.Spacing1)}
      color={withVar(DesignToken.ContentInvertSecondary)}
    >
      {keyName}
    </Text>
  </Flex>
);

export default KeyWrapper;
